import { Table } from '@mui/material';
import { memo } from 'react';

import { catalogProductTableSx } from './catalogProductTableSpec';

import type { TableProps } from '@mui/material';

export const CatalogProductTable = memo(
    ({ sx, children, ...tableProps }: TableProps) => (
        <Table
            {...tableProps}
            sx={[
                catalogProductTableSx,
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
        >
            {children}
        </Table>
    ),
);

CatalogProductTable.displayName = 'CatalogProductTable';
